<template>
  <rich-button @click="commands.strike" v-bind:isActive="isActive.strike()" v-bind:icon="'strikethrough'" />
</template>

<script>
  import StrikethroughButton from './StrikethroughButton.ts'
  export default StrikethroughButton
</script>
